import Image from 'src/components/atoms/Image';

import WidgetItem from 'src/components/organisms/events/WidgetItem';
import Event from 'src/models/Event';
import { useSelector } from 'src/hooks/useSelector';
import SearchBar from 'src/components/organisms/SearchBar/Widget';
import ButtonLink from 'src/components/atoms/ButtonLink';
import CreateEventButton from 'src/components/molecules/CreateEventButton';
import poweredByEvvnt from 'src/assets/images/powered_by_evvnt.png';
import WidgetAd from '../../molecules/WidgetAd';
import { Fragment } from 'react';
import { createListWithAds } from '../../../utils/adHelper';
import { exists } from '../../../utils/objects';

const WidgetPortrait = ({ rawEvents, adPosition, category }) => {
  const publisherSettings = useSelector((state) => state.publisherSettings);
  const events = rawEvents.map((event) => new Event(event, publisherSettings));
  const listWithAds = createListWithAds(events, exists(adPosition) ? [adPosition] : []);

  const EventsGrid = ({ children }) => (
    <div className="grid gap-2 mt-2 bg-white">{children}</div>
  );

  const EventsContainer = ({ children }) => (
    <div className="flex-1 relative z-1 @md:px-2 @lg:ml-0  bg-white rounded">{children}</div>
  );

  return (
    <main className="flex flex-col items-center text-gray-900 max-w-lg m-auto">
      <CreateEventButton extraClasses="w-full mb-2 uppercase text-sm" />
      <SearchBar category={category} />

      <div className="flex mt-0 w-full" id="main-container">
        <EventsContainer>
          <EventsGrid data-testid="widget-event-list">
            {listWithAds.map((listElement, index) => (
              <Fragment key={`event-list-item-${index}`}>
                {listElement.isAd && (
                  <WidgetAd
                    widgetType="vertical_widget"
                    utmSource={publisherSettings.publisher.id}
                    utmMedium="widget"
                    utmCampaign="promote_asset"
                  />
                )}
                {!listElement.isAd && (
                  <WidgetItem event={listElement.event} trackView={true} />
                )}
              </Fragment>
            ))}
            <ButtonLink
              text="More Events"
              href={publisherSettings.publisher.url}
              target="_top"
              extraClasses="font-semibold shadow-none text-sm"
            />
            <div>
              <a
                href="http://evvnt.com"
                target="_blank"
                className="block float-right"
                rel="noopener"
              >
                <Image src={poweredByEvvnt} height={21} width={124} alt="Powered by Evvnt" />
              </a>
            </div>
          </EventsGrid>
        </EventsContainer>
      </div>
    </main>
  );
};

export default WidgetPortrait;
